import capitalize from "lodash.capitalize"

export const ANNUALLY = "ANNUALLY"
export const MONTHLY = "MONTHLY"
export const QUARTERLY = "QUARTERLY"
export const SEMI_ANNUALLY = "SEMI_ANNUALLY"

const DistributionFrequencyEnum = {
  [ANNUALLY]: ANNUALLY,
  [MONTHLY]: MONTHLY,
  [QUARTERLY]: QUARTERLY,
  [SEMI_ANNUALLY]: SEMI_ANNUALLY
}

const DistributionFrequencyEnumKeys = Object.keys(DistributionFrequencyEnum)

const DistributionFrequencyEnumOptions = DistributionFrequencyEnumKeys
  .map(value => ({
    label: capitalize(value),
    value
  }))

export {
  DistributionFrequencyEnumKeys,
  DistributionFrequencyEnumOptions
}

export default DistributionFrequencyEnum
